import LeaderBoardList from "./LeaderBoardList"

export default  LeaderBoardList;
